export default {
  paperClass: {
    margin: ({ margin }) => margin || null
  }
}
